import { render } from "./AdvertiserList.vue?vue&type=template&id=5055820e&scoped=true"
import script from "./AdvertiserList.vue?vue&type=script&lang=js"
export * from "./AdvertiserList.vue?vue&type=script&lang=js"

import "./AdvertiserList.vue?vue&type=style&index=0&id=5055820e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5055820e"]])

export default __exports__